// AUTO-GENERATED from servers/common-servers-v2/helpers/FormHelper/date.js by servers/common-servers-v2/scripts/sync-form-helper.js.
// Do not edit: change the source and run `node scripts/sync-form-helper.js`.
/* eslint-disable */
import { DATE_MODES, DEFAULT_DATE_MODE } from "./constants.js";

/*
 * Date fields have no time and are stored in the Gregorian calendar (spec §5):
 *   day   -> "YYYY-MM-DD"
 *   month -> "YYYY-MM"
 *   year  -> "YYYY"
 * They are displayed in Jalali. A Jalali month or year does not line up with a
 * Gregorian one, so the partial modes use a fixed representative day that makes
 * the round trip lossless:
 *   month: the 15th day of the Jalali month is stored as its Gregorian "YYYY-MM"
 *          and read back through the 15th of that Gregorian month;
 *   year:  1 Mehr of the Jalali year is stored as its Gregorian "YYYY" and read
 *          back through 1 July of that year.
 */

const MONTH_ANCHOR_DAY = 15;
const YEAR_ANCHOR_MONTH = 7;
const YEAR_ANCHOR_DAY = 1;

const GREGORIAN_MONTH_DAYS = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const GREGORIAN_OFFSETS = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];

const div = (a, b) => Math.trunc(a / b);

const is_gregorian_leap = (year) => (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;

const gregorian_days_in_month = (year, month) => (month === 2 && is_gregorian_leap(year) ? 29 : GREGORIAN_MONTH_DAYS[month - 1]);

const is_valid_gregorian = (year, month, day) => Number.isInteger(year) && Number.isInteger(month) && Number.isInteger(day)
    && year >= 1 && year <= 9999 && month >= 1 && month <= 12 && day >= 1 && day <= gregorian_days_in_month(year, month);

const gregorian_to_jalali = (gy, gm, gd) => {
    let jy;
    let year = gy;
    if (year > 1600) {
        jy = 979;
        year -= 1600;
    } else {
        jy = 0;
        year -= 621;
    }
    const year2 = gm > 2 ? year + 1 : year;
    let days = (365 * year) + div(year2 + 3, 4) - div(year2 + 99, 100) + div(year2 + 399, 400) - 80 + gd + GREGORIAN_OFFSETS[gm - 1];
    jy += 33 * div(days, 12053);
    days %= 12053;
    jy += 4 * div(days, 1461);
    days %= 1461;
    if (days > 365) {
        jy += div(days - 1, 365);
        days = (days - 1) % 365;
    }
    const jm = days < 186 ? 1 + div(days, 31) : 7 + div(days - 186, 30);
    const jd = 1 + (days < 186 ? days % 31 : (days - 186) % 30);
    return [jy, jm, jd];
};

const jalali_to_gregorian = (jy, jm, jd) => {
    let gy;
    let year = jy;
    if (year > 979) {
        gy = 1600;
        year -= 979;
    } else {
        gy = 621;
    }
    let days = (365 * year) + (div(year, 33) * 8) + div((year % 33) + 3, 4) + 78 + jd + (jm < 7 ? (jm - 1) * 31 : ((jm - 7) * 30) + 186);
    gy += 400 * div(days, 146097);
    days %= 146097;
    if (days > 36524) {
        days -= 1;
        gy += 100 * div(days, 36524);
        days %= 36524;
        if (days >= 365) {
            days += 1;
        }
    }
    gy += 4 * div(days, 1461);
    days %= 1461;
    if (days > 365) {
        gy += div(days - 1, 365);
        days = (days - 1) % 365;
    }
    let gd = days + 1;
    let gm = 0;
    for (; gm < 12; gm += 1) {
        const month_days = gregorian_days_in_month(gy, gm + 1);
        if (gd <= month_days) {
            break;
        }
        gd -= month_days;
    }
    return [gy, gm + 1, gd];
};

const pad = (value, length) => String(value).padStart(length, "0");

const resolve_mode = (mode) => (DATE_MODES.includes(mode) ? mode : DEFAULT_DATE_MODE);

const DATE_PATTERNS = {
    day: /^(\d{4})-(\d{2})-(\d{2})$/,
    month: /^(\d{4})-(\d{2})$/,
    year: /^(\d{4})$/,
};

// Parses a stored date. Returns { year, month, day } (Gregorian) or null.
const parse_stored_date = (value, mode) => {
    if (typeof value !== "string") {
        return null;
    }
    const resolved = resolve_mode(mode);
    const match = DATE_PATTERNS[resolved].exec(value);
    if (!match) {
        return null;
    }
    const year = Number(match[1]);
    const month = resolved === "year" ? 1 : Number(match[2]);
    const day = resolved === "day" ? Number(match[3]) : 1;
    if (year < 1000 || !is_valid_gregorian(year, month, day)) {
        return null;
    }
    return { year, month, day };
};

// Stored Gregorian value -> Jalali parts for display. `month`/`day` are omitted for the partial modes.
const stored_to_jalali = (value, mode) => {
    const resolved = resolve_mode(mode);
    const parsed = parse_stored_date(value, resolved);
    if (!parsed) {
        return null;
    }
    if (resolved === "day") {
        const [jy, jm, jd] = gregorian_to_jalali(parsed.year, parsed.month, parsed.day);
        return { year: jy, month: jm, day: jd };
    }
    if (resolved === "month") {
        const [jy, jm] = gregorian_to_jalali(parsed.year, parsed.month, MONTH_ANCHOR_DAY);
        return { year: jy, month: jm };
    }
    const [jy] = gregorian_to_jalali(parsed.year, YEAR_ANCHOR_MONTH, YEAR_ANCHOR_DAY);
    return { year: jy };
};

// Jalali parts picked by the user -> value to store. Returns null when the date does not exist.
const jalali_to_stored = (parts, mode) => {
    const resolved = resolve_mode(mode);
    if (!parts || !Number.isInteger(parts.year)) {
        return null;
    }
    if (resolved === "year") {
        const [gy] = jalali_to_gregorian(parts.year, 7, 1);
        return pad(gy, 4);
    }
    if (!Number.isInteger(parts.month) || parts.month < 1 || parts.month > 12) {
        return null;
    }
    if (resolved === "month") {
        const [gy, gm] = jalali_to_gregorian(parts.year, parts.month, MONTH_ANCHOR_DAY);
        return `${pad(gy, 4)}-${pad(gm, 2)}`;
    }
    const max_day = parts.month <= 6 ? 31 : parts.month <= 11 ? 30 : null;
    if (!Number.isInteger(parts.day) || parts.day < 1 || (max_day && parts.day > max_day) || parts.day > 31) {
        return null;
    }
    const [gy, gm, gd] = jalali_to_gregorian(parts.year, parts.month, parts.day);
    // Esfand 30 only exists in a Jalali leap year: the round trip tells.
    const back = gregorian_to_jalali(gy, gm, gd);
    if (back[0] !== parts.year || back[1] !== parts.month || back[2] !== parts.day) {
        return null;
    }
    return `${pad(gy, 4)}-${pad(gm, 2)}-${pad(gd, 2)}`;
};

const to_display_digits = (text, digits) => {
    if (digits !== "fa") {
        return text;
    }
    return text.replace(/\d/g, (char) => String.fromCharCode(0x06f0 + Number(char)));
};

// "1405/07/26", "1405/07" or "1405" for a stored value; "" when invalid.
const format_stored_date = (value, mode, options = {}) => {
    const parts = stored_to_jalali(value, mode);
    if (!parts) {
        return "";
    }
    const pieces = [pad(parts.year, 4)];
    if (parts.month) {
        pieces.push(pad(parts.month, 2));
    }
    if (parts.day) {
        pieces.push(pad(parts.day, 2));
    }
    return to_display_digits(pieces.join("/"), options.digits);
};

export {
    is_valid_gregorian,
    gregorian_to_jalali,
    jalali_to_gregorian,
    parse_stored_date,
    stored_to_jalali,
    jalali_to_stored,
    format_stored_date,
};
